import { useAppSelector } from '../hooks'

export const useUserSelector = () => useAppSelector((state) => state.auth.user)
export const useUserRole = () => useAppSelector((state) => state.auth?.user?.role)
